import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { Image, Title, Description } from "@/ui";
import classes from "./styles.module.scss";

export default function Benefits({ sectionId, className, bgColor, title, titleColor, description, items }) {
  return (
    <div id={sectionId} className={clsx(className, bgColor, classes.Benefits)}>
      <Container>
        <Title title={title} className={clsx(titleColor, "mb-4")} />
        <Description description={description} />
        <Row className="mt-5">
          {items.map((i, k) => (
            <Col key={k} xs={12} md={4} className="mb-4">
              <div className={classes.Benefits__item}>
                <Image img={i?.img?.url} size="50x50" alt="" />
                <div>
                  <Title title={i?.title} tag="h3" className="h4" />
                  <Description description={i?.description} />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
